export default __webpack_public_path__ + "static/media/img-42-bari.08c3ba4a.jpg";